/**
* Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


function addToCartNowCart(items){
    let formData = {
      'items': items
    }

       fetch(window.Shopify.routes.root + 'cart/add.js', {
         method: 'POST',
         headers: {
           'Content-Type': 'application/json'
         },
         body: JSON.stringify(formData)
       })
       .then(response => {
         return response.json().then((data)=>{
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
               bubbles: true
            }));
         });
       })
       .catch((error) => {
         console.error('Error:', error);
       });
};

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
      c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
      }
  }
  return "";
}

function closeTopBarDiscount(){
  var discountBar = document.querySelector('.discount-bar');
  var closeBar = document.querySelector('.discount-bar .close-button');

  if(discountBar != null) {
    if(!getCookie('topBarDiscount')){
        discountBar.classList.add('active');
    } else {
        
    }
  
    closeBar.addEventListener('click', function(e){
      setCookie('topBarDiscount','closed',1);
      discountBar.classList.remove('active');
    });
  }


}
closeTopBarDiscount();

var topBarPopup = document.getElementById("top-cta");
var sidePopup = document.querySelector(".drawer-discount .side-discount-wrapper");
if(topBarPopup) {
  topBarPopup.addEventListener('click', function(e){
    e.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'UgcrnV']);
  });
}

if(sidePopup){
  sidePopup.addEventListener('click', function(e){
    e.preventDefault();
    console.log('sidepopup');
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'RvDdPT']);
  });
}

/* ex GST price calculation on product page */
document.addEventListener("DOMContentLoaded", function () {
  // Select the container element
  const priceListElement = document.querySelector(".product-form__price-container .price-list");
  const exGSTElement = document.querySelector("#productExGSTPrice");

  if (priceListElement && exGSTElement) {
    // Function to calculate and update the exclusive GST price
    const updateExGSTPrice = () => {
      const priceElement = priceListElement.querySelector(".price"); // Select the first .price element
      if (priceElement) {
        // Ignore visually hidden elements and extract the visible text
        const visiblePriceText = Array.from(priceElement.childNodes)
          .filter(node => !(node.nodeType === Node.ELEMENT_NODE && node.classList.contains("visually-hidden"))) // Filter hidden nodes
          .map(node => node.textContent.trim()) // Extract visible text
          .join(""); // Combine visible text

        const priceValue = parseFloat(visiblePriceText.replace(/[^\d.]/g, "")); // Remove non-numeric characters
        if (!isNaN(priceValue)) {
          const exGSTPrice = (priceValue / 1.1).toFixed(2); // Calculate exclusive GST price
          exGSTElement.textContent = `($${exGSTPrice} excl GST)`; // Update the target element
        }
      }
    };

    // Observe changes in the .product-form__price-list container
    const observer = new MutationObserver(updateExGSTPrice);

    observer.observe(priceListElement, { childList: true, subtree: true }); // Observe relevant changes

    // Initial calculation
    updateExGSTPrice();
  }
});


//External fetch request hook - Listens for Add to Cart events triggered by Boost Search App on Collection pages
const fetchRequests = window.fetch;

window.fetch = async (...args) => {
  const [resource, config] = args;

  if (typeof resource === "string" && resource.includes("/cart/add.js") && window.location.href.includes('collections')) {
    document.dispatchEvent(
      new CustomEvent("externalAddToCart", { detail: { resource, config } })
    );
  }

  return fetchRequests(...args);
};

document.addEventListener("externalAddToCart", (e) => {
  console.log("Caught add to cart!", e.detail);
  setTimeout(() => {
    document.documentElement.dispatchEvent(new CustomEvent('product:added', {
    bubbles: true,
      detail: {
        quantity: JSON.parse(e.detail.config.body).items[0].quantity
      }
    }));
  }, 1000)
});